export function Covers({ items }: { items: string[][] }) {
  return (
    <div className="cards-2" style={{ marginBottom: "3rem" }}>
      {items.map(([title, body]) => (
        <article className="cover card" key={title}>
          <h3>{title}</h3>
          <p className="soft" style={{ fontSize: "0.875rem", margin: 0 }}>{body}</p>
        </article>
      ))}
    </div>
  );
}
